// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: Arial, sans-serif;
}

.sidebar-menu-button {
  display: none;
  margin-right: 14px;
  border: 1px solid #475569;
  border-radius: 7px;
  padding: 6px 9px;
  background: transparent;
  color: #fff;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}

.sidebar-overlay {
  display: none;
}

@media (max-width: 1199px) {
  .sidebar-menu-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .sidebar-overlay {
    display: block;
    position: fixed;
    inset: 60px 0 0;
    z-index: 1090;
    border: 0;
    background: rgba(15, 23, 42, 0.42);
    cursor: pointer;
  }
}

.route-back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 16px 0 4px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 8px 12px;
  background: #ffffff;
  color: #334155;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.route-back-button:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}


.card-global {
  /* background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border: 1px solid #eee;
  transition: transform 0.2s ease, box-shadow 0.2s ease; */
  background: #fdf6e3;
  color: black;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #2c2c3a;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
}

.auth-signin-btn {
  padding: 7px 16px;
  border-radius: 8px;
  border: 1px solid #0f766e;
  background: #0f766e;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
}

.auth-signin-btn:hover {
  background: #0d635c;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,SAAS;IACT,kCAAkC;IAClC,eAAe;EACjB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;;AAGA;EACE;;;;;0DAKwD;EACxD,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["body {\n  margin: 0;\n  font-family: Arial, sans-serif;\n}\n\n.sidebar-menu-button {\n  display: none;\n  margin-right: 14px;\n  border: 1px solid #475569;\n  border-radius: 7px;\n  padding: 6px 9px;\n  background: transparent;\n  color: #fff;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.sidebar-overlay {\n  display: none;\n}\n\n@media (max-width: 1199px) {\n  .sidebar-menu-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .sidebar-overlay {\n    display: block;\n    position: fixed;\n    inset: 60px 0 0;\n    z-index: 1090;\n    border: 0;\n    background: rgba(15, 23, 42, 0.42);\n    cursor: pointer;\n  }\n}\n\n.route-back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 16px 0 4px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  padding: 8px 12px;\n  background: #ffffff;\n  color: #334155;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.route-back-button:hover {\n  border-color: #94a3b8;\n  background: #f8fafc;\n}\n\n\n.card-global {\n  /* background: #ffffff;\n  border-radius: 12px;\n  padding: 16px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  border: 1px solid #eee;\n  transition: transform 0.2s ease, box-shadow 0.2s ease; */\n  background: #fdf6e3;\n  color: black;\n  border-radius: 12px;\n  padding: 16px;\n  border: 1px solid #2c2c3a;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);\n}\n\n.auth-signin-btn {\n  padding: 7px 16px;\n  border-radius: 8px;\n  border: 1px solid #0f766e;\n  background: #0f766e;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.auth-signin-btn:hover {\n  background: #0d635c;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
